/**
 * Frontend JS
 */
import '../scss/frontend.scss';

(function ($) {
  // Increments
  function ticketIncrements() {
    const increment = (button, num, e) => {
      const input = $(button).siblings("input[type=number]");
      let int = parseInt(e.val()) + num;
      // Check min/max range
      if (input.attr("min") != undefined) {
        int = Math.max(int, parseInt(input.attr("min")));
      }
      if (input.attr("max") != undefined) {
        int = Math.min(int, parseInt(input.attr("max")));
      }
      input.val(int);
    };

    $(document.body).on("click", ".ticket_subtract", (event) => {
      event.preventDefault();
      increment(this, -1, event);
    });

    $(document.body).on("click", ".ticket_add", (event) => {
      event.preventDefault();
      increment(this, 1, event);
    });
  }

  // Reports
  function reports() {
    const $table = $(".revenue-report__table");
    if (!$table.length) return;

    if ($table.find("thead th").length === 3) {
      $table.find("thead th:nth-child(2)").remove();
    }

    if ($table.find("tbody td.revenue-report__event-tickets").length) {
      $table.find("tbody td.revenue-report__event-tickets").remove();
    }
  }

  // Checkout quantity
  function checkoutQuantity() {
    // Cart only
    if (!$("#order_review .cart_item").length) return;

    $(document).on("click", "[data-quantity-add]", (event) => {
      const $quantity = $(event.currentTarget).parent(".quantity");
      const $input = $("#ticket-quantity", $quantity);
      const quantity = Number($input.val());
      const newVal = quantity >= 20 ? 20 : quantity + 1;
      $input.val(newVal).change();
    });

    $(document).on("click", "[data-quantity-remove]", (event) => {
      const $quantity = $(event.currentTarget).parent(".quantity");
      const $input = $("#ticket-quantity", $quantity);
      const quantity = Number($input.val());
      const newVal = quantity <= 1 ? 1 : quantity - 1;
      $input.val(newVal).change();
    });
  }

  // Logo
  function branding() {
    const isCheckout = $(`body`).hasClass(`woocommerce-checkout`);
    const isOrder = $(`.woocommerce > .woocommerce-order`);
    if (!isCheckout && !isOrder) return;

    const img = `/wp-content/plugins/wc-strawhouse/assets/img/powered-by-sbo.png`;
    const source = window.location.host;
    const url = `https://sarasotaboxoffice.com/?utm_source=${source}&utm_medium=customer-website&utm_campaign=checkout-powered-by`;
    const html = `<a class="sarasota-box-office-logo" href="${url}" target="_blank"><img src="${img}" alt="Powered by Sarasota Box Office" /></a>`;
    const $woocommerce = $("#main .woocommerce");
    $woocommerce.append(html);

    const $fusionLogo = $(`.fusion-image-element img[src*="powered-by-sbo"]`);
    if ($fusionLogo) {
      $fusionLogo.parents(".fusion-image-element").remove();
    }
  }

  // Free child discounts on checkout
  function freeChildDiscount() {
    const isCheckout = $(`body`).hasClass(`woocommerce-checkout`);
    if (!isCheckout) return;

    $(document.body).on("updated_checkout", (event) => {
      const config = window.freechild_discount;
      if (!config) return;
      const discounts = config.discounts;

      if ($.isEmptyObject(config) || config.active === false) return;
      if ($.isEmptyObject(discounts)) return;

      // BOGO discount path
      if (config.discount_type === "bogo") {
        $("#order_review").addClass("checkout-has-discounts checkout-bogo");
        $(`form[name="checkout"]`).parent(".woocommerce").addClass("checkout-bogo-discount");

        $("th:contains('BOGO discount')").parent("tr.fee").hide();

        // Update subtotal
        const discountedSubtotal = discounts.discounted_subtotal.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
        const originalSubtotal = discounts.subtotal.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
        const $subtotal = $(`#order_review .cart-subtotal td`);
        $subtotal.html(`<span class="discounted-subtotal">${discountedSubtotal}</span> <span class="discounted">${originalSubtotal}</span>`);

        // Update total
        const discountedTotal = discounts.discounted_total.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
        const originalTotal = discounts.total.toLocaleString("en-US", {
          style: "currency",
          currency: "USD",
        });
        const $total = $(`#order_review .order-total td`);
        $total.html(`<span class="discounted-subtotal">${discountedTotal}</span> <span class="discounted">${originalTotal}</span>`);

        setTimeout(() => {
          $(`#order_review .product-total, #order_review tfoot`).addClass("ready");
        });
        return;
      }

      // Free child discount path
      const adultTickets = config.adult_tickets;
      const childTickets = config.child_tickets;

      $("#order_review").addClass("checkout-has-discounts");

      $(`form[name="checkout"]`).parent(".woocommerce").addClass("checkout-freechild-discount");

      // Template replacements
      const totalDiscount = discounts.child_ticket_discounted.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      $(`[data-discounts="total-discount"]`).text(totalDiscount).parents(".woocommerce-message").addClass("woocommerce-message--success");
      $(`[data-discounts="discounted-children"]`).text(discounts.eligible_tickets);

      $("th:contains('Free child discount')").parent("tr.fee").hide();

      // Discount child ticket subtotal
      const discountChildTicket = discounts.child_ticket_discounted.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      const originalChildTicket = discounts.child_ticket_subtotal.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      const eligibleChildTicketNames = config.child_tickets;
      const $childProductName = $(`span.sh_product_name`)
        .filter((index, element) => {
          const $element = $(element);
          $element.find("img").remove();
          const text = $element.text().trim();
          return config.child_tickets.indexOf(text) > -1;
        })
        .first();
      const $childTicketSubtotal = $childProductName.parents("tr").find(`td.product-total`);
      $childTicketSubtotal.html(`<span class="discounted-subtotal">${discountChildTicket}</span> <span class="discounted">${originalChildTicket}</span>`);

      // Discount subtotal
      const discountedSubtotal = discounts.discounted_subtotal.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      const originalSubtotal = discounts.subtotal.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      const $subtotal = $(`#order_review .cart-subtotal td`);
      $subtotal.html(`<span class="discounted-subtotal">${discountedSubtotal}</span> <span class="discounted">${originalSubtotal}</span>`);

      // Total
      const discountedTotal = discounts.discounted_total.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      const originalTotal = discounts.total.toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
      const $total = $(`#order_review .order-total td`);
      $total.html(`<span class="discounted-subtotal">${discountedTotal}</span> <span class="discounted">${originalTotal}</span>`);

      setTimeout(() => {
        $(`#order_review .product-total, #order_review tfoot`).addClass("ready");
      });
    });
  }

  freeChildDiscount();
  ticketIncrements();
  checkoutQuantity();
  branding();
  reports();
})(window.jQuery);
